import { createSocketService } from "@/utils/socket-service-factory";
import { ServerConfig } from "@/config/config";

export const MainSocketService = createSocketService(ServerConfig.mainAppSocket, "/socket.io/admin/");